/* JALIZA try-on-core: shared offline Try-On job layer (ADR 0003).
   Consumed by braided-wig-try-on (sole product-section host) and my-try-on-gallery. No DOM opinions:
   the host module passes adapters (looks, render callbacks, quota copy).
   Backend contract (studio-admin):
     POST /apps/mediacreation/tryon-jobs (multipart: photo, productId, productType,
       color, length, wigImageUrl, wigAlt, specSnapshot?, clientRequestId via Idempotency-Key)
       -> { jobId, status: "pending", queuePosition }
       401 login / 429 quota / 422 no_wig_image { code }
     GET  /apps/mediacreation/tryon-jobs?product_id=&status=&cursor=
       -> { items: [{ jobId, productId, productType, color, length, skuImageUrl, skuThumbUrl?,
                      userPhotoUrl?, resultUrl?, resultThumbUrl?, specSnapshot?, status, qaScore?,
                      retryCount, createdAt, completedAt }], nextCursor? }
     GET  /apps/mediacreation/tryon-jobs/events?ids= (SSE, snapshot-first)
       event: { type: "job", job: { jobId, status, resultUrl?, qaScore? } }
     POST /apps/mediacreation/tryon-jobs/:jobId/retry  (failed only)
     POST /apps/mediacreation/tryon-jobs/:jobId/cancel (pending/processing) */
(function () {
  'use strict';
  if (window.JalizaTryOnCore) return;
  var API = '/apps/mediacreation/tryon-jobs';
  var EVENTS = '/apps/mediacreation/tryon-jobs/events';

  var TERMINAL = { done: 1, failed: 1, cancelled: 1 };

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'id-' + Date.now() + '-' + Math.floor(Math.random() * 1e9);
  }

  function normalizeItem(raw) {
    if (!raw) return null;
    var id = raw.jobId || raw.job_id || raw.id;
    if (!id) return null;
    return {
      id: String(id),
      status: String(raw.status || 'processing').toLowerCase(),
      resultUrl: raw.resultUrl || raw.result_url || raw.aiImageUrl || '',
      resultThumbUrl: raw.resultThumbUrl || raw.result_thumb_url || '',
      color: raw.color || raw.colorName || raw.color_name || '',
      length: raw.length == null ? '' : String(raw.length),
      density: raw.density || '',
      option1: raw.option1 || '',
      option2: raw.option2 || '',
      option3: raw.option3 || '',
      skuImageUrl: raw.skuImageUrl || raw.sku_image_url || raw.wigImageUrl || raw.wig_image_url || '',
      skuThumbUrl: raw.skuThumbUrl || raw.sku_thumb_url || '',
      sku: raw.sku || '',
      variantTitle: raw.variantTitle || raw.variant_title || '',
      productId: String(raw.productId || raw.product_id || raw.productID || ''),
      productHandle: String(raw.productHandle || raw.product_handle || raw.handle || ''),
      productTitle: String(raw.productTitle || raw.product_title || ''),
      styleTitle: String(raw.styleTitle || raw.style_title || raw.style || ''),
      kind: String(raw.kind || raw.productType || raw.product_type || '').toLowerCase(),
      productType: String(raw.productType || raw.product_type || '').toLowerCase(),
      specSnapshot: raw.specSnapshot || raw.spec_snapshot || null,
      foundation: String(raw.foundation || raw.foundationName || raw.foundation_name || ''),
      price: raw.price != null ? Number(raw.price) : null,
      packs: (raw.packs != null && String(raw.packs) !== '' ? String(raw.packs) : ''),
      packQty: raw.packQty != null ? String(raw.packQty) : (raw.pack_qty != null ? String(raw.pack_qty) : ''),
      packUnit: raw.packUnit || raw.pack_unit || '',
      variantId: String(raw.variantId || raw.variant_id || raw.variantID || ''),
      variantOption1: raw.variantOption1 || raw.variant_option1 || '',
      variantOption2: raw.variantOption2 || raw.variant_option2 || '',
      variantOption3: raw.variantOption3 || raw.variant_option3 || '',
      sourceSlot: String(raw.sourceSlot || raw.source_slot || 'front'),
      retryCount: Number(raw.retryCount || raw.retry_count || 0),
      qaScore: raw.qaScore != null ? Number(raw.qaScore) : (raw.qa_score != null ? Number(raw.qa_score) : null),
      failCode: raw.failCode || raw.fail_code || '',
      createdAt: raw.createdAt || raw.created_at || '',
      completedAt: raw.completedAt || raw.completed_at || ''
    };
  }

  function createClient() {
    var listeners = [];
    var jobs = {};
    var order = [];
    var sse = null;
    var sseBackstop = null;
    var historyLoadedFor = {};

    function emit(change) {
      for (var i = 0; i < listeners.length; i++) {
        try { listeners[i](change); } catch (e) {}
      }
    }
    function onChange(fn) { listeners.push(fn); return fn; }

    function upsert(rawOrNorm, opts) {
      var n = rawOrNorm && rawOrNorm.id ? rawOrNorm : normalizeItem(rawOrNorm);
      if (!n) return null;
      var prev = jobs[n.id];
      if (prev) {
        for (var k in n) { if (n[k] !== '' && n[k] !== null && n[k] !== undefined) prev[k] = n[k]; }
        if (n.status) prev.status = n.status;
      } else {
        jobs[n.id] = n;
        order.unshift(n.id);
        if (order.length > 50) {
          var drop = order.pop();
          if (drop) delete jobs[drop];
        }
      }
      var cur = jobs[n.id];
      if (!TERMINAL[cur.status]) ensureSubscribed(cur.id);
      emit({ kind: (opts && opts.kind) || (prev ? 'update' : 'add'), job: cur });
      return cur;
    }

    function list() {
      var out = [];
      for (var i = 0; i < order.length; i++) { if (jobs[order[i]]) out.push(jobs[order[i]]); }
      return out;
    }
    function get(id) { return jobs[id] || null; }
    function pendingCount() {
      var c = 0;
      for (var i = 0; i < order.length; i++) {
        var j = jobs[order[i]];
        if (j && !TERMINAL[j.status]) c++;
      }
      return c;
    }

    function apiError(res) {
      return res.json().catch(function () { return {}; }).then(function (body) {
        var err = new Error('tryon:' + res.status);
        err.status = res.status;
        err.code = (body && (body.code || body.error)) || '';
        /* 配额 429 文案区分：用完 vs 并发满 */
        if (res.status === 429) {
          err.quotaMessage = err.code === 'concurrent_limited'
            ? 'You have 2 Try-Ons still processing. Wait for one to finish, then try again.'
            : 'You\'ve used all 10 AI Try-Ons today! Come back tomorrow for more.';
        }
        return Promise.reject(err);
      });
    }
    function quotaErrorMessage(err, fallback) {
      if (err && err.status === 429) return err.quotaMessage || fallback || 'You\'ve used all 10 AI Try-Ons today! Come back tomorrow for more.';
      return null;
    }

    function submit(form) {
      var key = uuid();
      /* clientRequestId 必须进 FormData：后端只读 form 字段做幂等，header 会被 App Proxy 吞掉 */
      try { if (form && form.append && !form.get('clientRequestId')) form.append('clientRequestId', key); } catch (e) {}
      return fetch(API, {
        method: 'POST',
        body: form,
        credentials: 'same-origin',
        headers: { 'Idempotency-Key': key, 'X-Client-Request-Id': key }
      }).then(function (res) {
        if (!res.ok) return apiError(res);
        return res.json();
      }).then(function (body) {
        return upsert({ jobId: body.jobId || body.job_id, status: body.status || 'pending' }, { kind: 'submit' });
      });
    }

    var quotaState = null;
    var quotaListeners = [];
    function getQuota() { return quotaState; }
    function onQuota(fn) { if (typeof fn === 'function') quotaListeners.push(fn); return fn; }
    function emitQuota() {
      for (var qi = 0; qi < quotaListeners.length; qi++) {
        try { quotaListeners[qi](quotaState); } catch (e) {}
      }
    }
    function fetchHistory(productId, status) {
      var key = String(productId) + '|' + (status || 'all');
      if (historyLoadedFor[key]) return Promise.resolve(list());
      var url = API + '?status=' + encodeURIComponent(status || 'all');
      /* '__all__'/空 = 跨产品（Gallery 页）；否则按产品过滤 */
      if (productId && productId !== '__all__') {
        url += '&product_id=' + encodeURIComponent(String(productId));
      }
      return fetch(url, { credentials: 'same-origin' }).then(function (res) {
        if (!res.ok) return apiError(res);
        return res.json();
      }).then(function (body) {
        var items = (body && body.items) || [];
        if (body && body.quota) {
          quotaState = {
            enabled: !!body.quota.enabled,
            limit: Number(body.quota.limit) || 10,
            usedToday: Number(body.quota.usedToday) || 0,
            remainingToday: body.quota.remainingToday == null ? 10 : Math.max(Number(body.quota.remainingToday) || 0, 0)
          };
          emitQuota();
        }
        items.forEach(function (raw) { upsert(raw, { kind: 'sync' }); });
        historyLoadedFor[key] = true;
        emit({ kind: 'sync', job: null });
        return list();
      });
    }

    /* 只刷 quota（打开弹窗/提交前用）：清掉 history 缓存键强制走一次 GET，失败静默 */
    function refreshQuota(productId) {
      try {
        delete historyLoadedFor[String(productId) + '|all'];
      } catch (e) {}
      return fetchHistory(productId, 'all').catch(function () { return list(); });
    }

    function refreshJobs(ids) {
      if (!ids || !ids.length) return Promise.resolve([]);
      delete historyLoadedFor['__all__|all'];
      delete historyLoadedFor['__refresh__|all'];
      return fetchHistory('__all__', 'all').then(function () {
        return ids.map(get).filter(Boolean);
      }).catch(function () { return ids.map(get).filter(Boolean); });
    }

    function stopStream() {
      if (sse) { try { sse.close(); } catch (e) {} sse = null; }
      if (sseBackstop) { clearTimeout(sseBackstop); sseBackstop = null; }
    }

    function ensureSubscribed(hintId) {
      var open = order.filter(function (id) { var j = jobs[id]; return j && !TERMINAL[j.status]; });
      if (!open.length) { stopStream(); return; }
      var want = EVENTS + '?ids=' + encodeURIComponent(open.join(','));
      if (sse && sse._url === want &&
          (sse.readyState === EventSource.OPEN || sse.readyState === EventSource.CONNECTING)) return;
      stopStream();
      var source;
      try { source = new EventSource(want); }
      catch (e) {
        sseBackstop = setTimeout(function () { emit({ kind: 'stream-error', job: hintId ? get(hintId) : null }); }, 90000);
        return;
      }
      source._url = want;
      sse = source;
      source.addEventListener('message', function (event) {
        var data = null;
        try { data = JSON.parse(event.data); } catch (e) { return; }
        if (!data || data.type !== 'job' || !data.job) return;
        upsert(data.job.jobId ? data.job : {
          jobId: data.job.jobId || data.job.job_id,
          status: data.job.status,
          resultUrl: data.job.resultUrl || data.job.result_url,
          qaScore: data.job.qaScore != null ? data.job.qaScore : data.job.qa_score
        }, { kind: 'event' });
        if (!pendingCount()) stopStream();
      });
      source.addEventListener('error', function () {
        clearTimeout(sseBackstop);
        sseBackstop = setTimeout(function () {
          stopStream();
          emit({ kind: 'stream-error', job: hintId ? get(hintId) : null });
        }, 90000);
      });
    }

    /* retry = 按重新提交语义：后端建新单（新 jobId），前端跟踪新单并订阅推送。
       附带 kind=regenerate：后端 quota 豁免（单图 5 次上限由前端 + 后端 retryCount 双控）。 */
    function retry(jobId) {
      return fetch(API + '/' + encodeURIComponent(jobId) + '/retry', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ kind: 'regenerate' })
      }).then(function (res) {
        if (!res.ok) return apiError(res);
        return res.json();
      }).then(function (body) {
        var nid = body && (body.jobId || body.job_id);
        if (!nid) return upsert({ jobId: jobId, status: (body && body.status) || 'pending' }, { kind: 'retry' });
        var cur = upsert({ jobId: nid, status: (body && body.status) || 'queued' }, { kind: 'retry' });
        ensureSubscribed(nid);
        return cur;
      });
    }

    function deleteJob(jobId) {
      return fetch(API + '?jobId=' + encodeURIComponent(jobId), {
        method: 'DELETE', credentials: 'same-origin'
      }).then(function (res) {
        if (!res.ok) return apiError(res);
        return res.json();
      }).then(function (body) {
        if (body && body.deleted) {
          delete jobs[jobId];
          var oi = order.indexOf(jobId);
          if (oi !== -1) order.splice(oi, 1);
          emit({ kind: 'remove', job: null });
          return { deleted: true };
        }
        return upsert({ jobId: jobId, status: (body && body.status) || 'cancelled' }, { kind: 'cancel' });
      });
    }

    function cancel(jobId) {
      return fetch(API + '/' + encodeURIComponent(jobId) + '/cancel', {
        method: 'POST', credentials: 'same-origin'
      }).then(function (res) {
        if (!res.ok) return apiError(res);
        return res.json();
      }).then(function (body) {
        return upsert({ jobId: jobId, status: (body && body.status) || 'cancelled' }, { kind: 'cancel' });
      });
    }

    var SOURCE_API = '/apps/mediacreation/source-photo';
    function listSourcePhotos() {
      return fetch(SOURCE_API, { credentials: 'same-origin' }).then(function (res) {
        if (!res.ok) return apiError(res);
        return res.json();
      }).then(function (body) { return (body && body.photos) || []; });
    }
    function uploadSourcePhoto(file, slot) {
      var form = new FormData();
      form.append('photo', file, (file && file.name) || 'source.jpg');
      form.append('slot', slot || 'front');
      form.append('consent', 'true');
      return fetch(SOURCE_API, { method: 'POST', body: form, credentials: 'same-origin' }).then(function (res) {
        if (!res.ok) return apiError(res);
        return res.json();
      }).then(function (body) { return body && body.photo; });
    }
    function deleteSourcePhoto(slot) {
      return fetch(SOURCE_API + '?slot=' + encodeURIComponent(slot || 'front'), {
        method: 'DELETE', credentials: 'same-origin'
      }).then(function (res) {
        if (!res.ok) return apiError(res);
        return res.json();
      });
    }

    return {
      submit: submit,
      fetchHistory: fetchHistory,
      refreshQuota: refreshQuota,
      listSourcePhotos: listSourcePhotos,
      uploadSourcePhoto: uploadSourcePhoto,
      deleteSourcePhoto: deleteSourcePhoto,
      refreshJobs: refreshJobs,
      ensureSubscribed: ensureSubscribed,
      stopStream: stopStream,
      retry: retry,
      cancel: cancel,
      deleteJob: deleteJob,
      upsert: upsert,
      list: list,
      get: get,
      pendingCount: pendingCount,
      onChange: onChange,
      getQuota: getQuota,
      quotaErrorMessage: quotaErrorMessage,
      onQuota: onQuota,
      TERMINAL: TERMINAL
    };
  }

  /* Idempotent photo compress (unchanged semantics from braided module). */
  function compressPhoto(file, maxSide, quality) {
    return new Promise(function (resolve) {
      try {
        if (!file || file.type === 'image/gif') { resolve(file); return; }
        if (file.size <= 600 * 1024) { resolve(file); return; }
        var url = URL.createObjectURL(file);
        var img = new Image();
        img.onload = function () {
          URL.revokeObjectURL(url);
          try {
            var w = img.naturalWidth || img.width;
            var h = img.naturalHeight || img.height;
            if (!w || !h) { resolve(file); return; }
            var limit = maxSide || 1536;
            var scale = Math.min(1, limit / Math.max(w, h));
            if (scale >= 1 && file.size <= 1024 * 1024) { resolve(file); return; }
            var cv = document.createElement('canvas');
            cv.width = Math.max(1, Math.round(w * scale));
            cv.height = Math.max(1, Math.round(h * scale));
            var ctx = cv.getContext('2d');
            if (!ctx || !cv.toBlob) { resolve(file); return; }
            ctx.drawImage(img, 0, 0, cv.width, cv.height);
            cv.toBlob(function (blob) {
              if (!blob || blob.size >= file.size) { resolve(file); return; }
              resolve(blob);
            }, 'image/jpeg', quality || 0.85);
          } catch (e) { resolve(file); }
        };
        img.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
        img.src = url;
      } catch (e) { resolve(file); }
    });
  }

  /* Shared 3-step try-on flow (upload -> building -> still-processing).
     Both business modules delegate to this; only look-specific hooks differ:
       - resolveDialogs(): { virtual, quota, delay } x-modal elements
       - query(sel): scoped lookup that also sees body-moved x-modals
       - remaining(): () -> number (quota remaining today)
       - onEvent(name, detail): analytics hook (tryon_delay_notice etc.)
     Flow owns: quota modal, 25s delay reminder + remaining fill, close-and-check-later,
     loading-leave button, toast. Dialog open/close stays with the host (x-modal API differs). */
  var PROCESSING_REMINDER_DELAY = 25000;
  var QUOTA_EXHAUSTED_COPY = "You've used all 10 AI Try-Ons today! Come back tomorrow for more.";
  var STILL_PROCESSING_COPY = 'Your Try-On is still processing. Check My Try-On Gallery later.';
  var CHECK_LATER_COPY = 'Your Try-On will continue processing. Return through My Try-On Gallery.';

  function showToastIn(scope, message, duration) {
    var toast = null;
    try {
      toast = scope.query('[data-vto="toast"]') || document.querySelector('[data-vto="toast"]');
    } catch (e) { toast = null; }
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('show'); }, duration || 2400);
  }

  function showQuotaExhausted(flow) {
    if (typeof flow.refreshAllowance === 'function') {
      try { flow.refreshAllowance(); } catch (e) {}
    }
    if (typeof flow.refreshDialogs === 'function') {
      try { flow.refreshDialogs(); } catch (e) {}
    }
    if (typeof flow.bind === 'function') {
      try { flow.bind(); } catch (e) {}
    }
    var quota = flow.dialogs && flow.dialogs.quota;
    if (quota && quota.show) { try { quota.show(); } catch (e) {} return true; }
    showToastIn(flow, QUOTA_EXHAUSTED_COPY, 4200);
    return true;
  }

  function showDelayNotice(flow) {
    var remainEl = null;
    try { remainEl = flow.query('[data-vto="processingDelayRemaining"]'); } catch (e) { remainEl = null; }
    if (remainEl) {
      var left = 0;
      try { left = flow.remaining(); } catch (e) { left = 0; }
      remainEl.textContent = String(left);
    }
    var delay = flow.dialogs && flow.dialogs.delay;
    var virtual = flow.dialogs && flow.dialogs.virtual;
    var isLoading = virtual && virtual.getAttribute && virtual.getAttribute('data-state') === 'loading';
    if (delay && delay.show && isLoading && !delay.hasAttribute('open')) {
      try { delay.show(); } catch (e) {}
      if (typeof flow.onEvent === 'function') { try { flow.onEvent('tryon_delay_notice'); } catch (e) {} }
    }
  }

  function createFlow(host) {
    var flow = {
      dialogs: host.resolveDialogs(),
      query: host.query,
      remaining: host.remaining,
      refreshAllowance: host.refreshAllowance,
      onEvent: host.onEvent,
      delayTimer: null
    };
    flow.refreshDialogs = function () {
      try { flow.dialogs = host.resolveDialogs(); } catch (e) {}
      return flow.dialogs;
    };
    flow.toast = function (message, duration) { showToastIn(flow, message, duration); };
    flow.quotaExhausted = function () { return showQuotaExhausted(flow); };
    flow.delayNotice = function () { showDelayNotice(flow); };
    flow.scheduleReminder = function () {
      flow.clearReminder();
      flow.delayTimer = setTimeout(function () {
        flow.delayTimer = null;
        showDelayNotice(flow);
      }, PROCESSING_REMINDER_DELAY);
    };
    flow.clearReminder = function () {
      if (flow.delayTimer) { clearTimeout(flow.delayTimer); flow.delayTimer = null; }
    };
    /* "Close and check later" (delay modal primary + loading-leave button):
       close delay + virtual, keep backend job running, toast points to Gallery.
       用户走了：调 host.onUserLeave 由宿主清监听，done 不再弹结果。 */
    flow.checkLater = function () {
      try { if (typeof host.onUserLeave === 'function') host.onUserLeave(); } catch (e) {}
      var d = flow.dialogs || {};
      try { if (d.delay && d.delay.hide) d.delay.hide(); } catch (e) {}
      try { if (d.virtual && d.virtual.hide) d.virtual.hide(); } catch (e) {}
      showToastIn(flow, CHECK_LATER_COPY, 4200);
      if (typeof flow.onEvent === 'function') { try { flow.onEvent('tryon_check_later'); } catch (e) {} }
    };
    /* Header X while loading: close virtual only, job keeps processing. */
    flow.closeWhileLoading = function () {
      try { if (typeof host.onUserLeave === 'function') host.onUserLeave(); } catch (e) {}
      var v = flow.dialogs && flow.dialogs.virtual;
      try { if (v && v.hide) v.hide(); } catch (e) {}
      showToastIn(flow, STILL_PROCESSING_COPY, 3600);
      return true;
    };
    flow.bind = function () {
      flow.refreshDialogs();
      var root = host.root || document;
      var bindClose = function (sel, fn) {
        var el = null;
        try { el = flow.query(sel); } catch (e) { el = null; }
        if (!el) { try { el = root.querySelector(sel); } catch (e2) { el = null; } }
        if (!el) { try { el = document.querySelector(sel); } catch (e3) { el = null; } }
        if (el && !el._vtoFlowBound) { el._vtoFlowBound = true; el.addEventListener('click', fn); }
      };
      bindClose('[data-vto="closeAndCheckLater"]', function () { flow.checkLater(); });
      bindClose('[data-vto="loadingLeaveButton"]', function () { flow.checkLater(); });
      bindClose('[data-vto="quotaClose"]', function () {
        var q = flow.dialogs && flow.dialogs.quota;
        try { if (q && q.hide) q.hide(); } catch (e) {}
      });
      return flow;
    };
    /* Choose-your-photo slots (screenshot step 1): front/side saved angles.
       Renders into [data-vto="tryOnSourceSlots"]; host supplies:
         - getLookName(): current look title for "Select a saved angle for X"
         - usePhoto(slot, url): USE THIS PHOTO -> start generation with saved url
         - uploadSlot(slot): UPLOAD X PHOTO -> open file picker for that slot
         - deletePhoto(slot): remove saved angle (optional; default calls API)
       Slots are loaded via core listSourcePhotos() on openTryOn. */
    flow.slotLabel = function (slot) { return slot === 'side' ? 'Side view' : 'Front view'; };
    flow.escAttr = function (v) {
      return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    };
    flow.setPhotoMode = function (hasSaved) {
      var first = null;
      var saved = null;
      try { first = flow.query('[data-vto="firstPhotoUpload"]'); } catch (e) { first = null; }
      try { saved = flow.query('[data-vto="savedPhotoChoice"]'); } catch (e) { saved = null; }
      if (first) first.hidden = !!hasSaved;
      if (saved) saved.hidden = !hasSaved;
    };
    flow.renderSlots = function (slots) {
      var holder = null;
      try { holder = flow.query('[data-vto="tryOnSourceSlots"]'); } catch (e) { holder = null; }
      var data = slots || {};
      flow.setPhotoMode(!!(data.front || data.side));
      if (!holder) return;
      var name = '';
      try { name = (typeof host.getLookName === 'function' ? host.getLookName() : '') || ''; } catch (e) { name = ''; }
      var nameEl = null;
      try { nameEl = flow.query('[data-vto="savedPhotoLookName"]'); } catch (e) { nameEl = null; }
      if (nameEl) nameEl.textContent = name;
      holder.innerHTML = ['front', 'side'].map(function (slot) {
        var url = data[slot] || '';
        var label = flow.slotLabel(slot);
        if (url) {
          return '<article class="source-photo-slot"><figure>' +
            '<img src="' + flow.escAttr(url) + '" alt="Your ' + label.toLowerCase() + ' camera photo" loading="lazy" decoding="async" />' +
            '<figcaption>' + label + '</figcaption>' +
            '<button class="source-photo-delete" type="button" data-vto-slot-delete="' + slot + '" aria-label="Delete ' + label.toLowerCase() + ' photo">\u00d7</button>' +
            '</figure><button class="source-photo-use" type="button" data-vto-slot-use="' + slot + '">USE THIS PHOTO</button></article>';
        }
        return '<article class="source-photo-slot empty"><figure class="source-photo-empty-figure" tabindex="0" role="button" aria-label="Upload ' + label.toLowerCase() + ' photo" data-vto-slot-upload-figure="' + slot + '">' +
          '<div class="source-photo-placeholder"><span aria-hidden="true">\uff0b</span><strong>' + label + '</strong></div>' +
          '</figure><button class="source-photo-add" type="button" data-vto-slot-upload="' + slot + '">UPLOAD ' + slot.toUpperCase() + ' PHOTO</button></article>';
      }).join('');
      var bind = function (attr, fn) {
        Array.prototype.forEach.call(holder.querySelectorAll('[' + attr + ']'), function (btn) {
          if (btn._vtoSlotBound) return;
          btn._vtoSlotBound = true;
          btn.addEventListener('click', function (ev) {
            ev.stopPropagation();
            fn(btn.getAttribute(attr), btn);
          });
        });
      };
      bind('data-vto-slot-use', function (slot) {
        if (typeof host.usePhoto === 'function') { try { host.usePhoto(slot, data[slot] || ''); } catch (e) {} }
      });
      bind('data-vto-slot-upload', function (slot) {
        if (typeof host.uploadSlot === 'function') { try { host.uploadSlot(slot); } catch (e) {} }
      });
      Array.prototype.forEach.call(holder.querySelectorAll('[data-vto-slot-upload-figure]'), function (fig) {
        if (fig._vtoFigureBound) return;
        fig._vtoFigureBound = true;
        var go = function () {
          var slot = fig.getAttribute('data-vto-slot-upload-figure');
          if (typeof host.uploadSlot === 'function') { try { host.uploadSlot(slot); } catch (e) {} }
        };
        fig.addEventListener('click', function (ev) { ev.stopPropagation(); go(); });
        fig.addEventListener('keydown', function (ev) {
          if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); go(); }
        });
      });
      bind('data-vto-slot-delete', function (slot) {
        if (typeof host.deletePhoto === 'function') { try { host.deletePhoto(slot); } catch (e) {} }
      });
    };
    flow.loadSlots = function () {
      var client = null;
      try { client = (typeof host.getClient === 'function' ? host.getClient() : null) || host.client || null; } catch (e) { client = null; }
      /* 先画空槽位占位（UPLOAD FRONT/SIDE PHOTO），与标题同帧出现；接口回来只换图，不闪 */
      flow.renderSlots(flow._slots || {});
      if (!client || typeof client.listSourcePhotos !== 'function') { return Promise.resolve(flow._slots || {}); }
      return client.listSourcePhotos().then(function (photos) {
        var slots = { front: '', side: '' };
        (photos || []).forEach(function (ph) {
          if (ph && (ph.slot === 'front' || ph.slot === 'side') && ph.url) slots[ph.slot] = ph.url;
        });
        flow._slots = slots;
        flow.renderSlots(slots);
        return slots;
      }).catch(function () { return flow._slots || {}; });
    };
    return flow;
  }

  /* 结果大图弹窗共用驱动（商详与 gallery 都渲染 snippets/try-on-result-dialog.liquid）。
     host 需提供：
       - root: scope 根节点（找 data-vto-result-* 用）
       - client: core createClient()（retry / deleteJob / quotaErrorMessage）
       - findJob(id): 取 job（含 resultUrl / variantId / sku / productHandle / retryCount）
       - renderSpecs(job, { product, variant, container, cart }): 可选；宿主用 try-on-commerce 渲染动态规格
       - onCart(job, btn): 加购（各宿主调用 try-on-commerce.resolveJobAdd）
       - toast(msg, ms): 轻提示
       - afterDelete(id), afterRegenerate(newId): 删除/regen 后刷新宿主列表
       - canOpen(job): 可选；返回 false 时交由宿主自行处理（gallery 的 failed 重试）
       - confirmDelete(job): 可选；返回 true 时宿主已经弹确认框，core 不再直接删
       - failedCopy(job): 可选；失败态覆盖文案 { cart, regenerateHidden }
       - track(name): 埋点（可选）
     open(jobId) 打开并渲染；refresh(jobId) 供 SSE 推进时刷新。 */
  function createResultDialog(host) {
    var root = host.root || document;
    var q = function (sel) {
      var el = null;
      try { el = root.querySelector('[data-vto-result="' + sel + '"]'); } catch (e) { el = null; }
      if (!el) { try { el = document.querySelector('[data-vto-result="' + sel + '"]'); } catch (e2) { el = null; } }
      return el;
    };
    var dlgOf = function (el) {
      if (!el) return null;
      try { var m = el.closest('x-modal'); if (m) return m; } catch (e) {}
      return null;
    };
    var modal = function () { return dlgOf(q('image') || q('close')); };
    var show = function () { var m = modal(); if (m && m.show) { try { m.show(); } catch (e) {} } };
    var hide = function () { var m = modal(); if (m && m.hide) { try { m.hide(); } catch (e) {} } };
    var toast = function (msg, ms) { try { host.toast(msg, ms); } catch (e) {} };
    var track = function (name) { try { if (host.track) host.track(name); } catch (e) {} };
    var trunc = function (v, n) {
      v = String(v == null ? '' : v);
      return v.length > n ? v.slice(0, n - 1) + '\u2026' : v;
    };
    var money = function (cents) {
      if (cents == null || isNaN(Number(cents))) return '';
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' }).format(Number(cents) / 100); }
      catch (e) { return '$' + (Number(cents) / 100).toFixed(2); }
    };
    var variantOf = function (job) {
      var v = job && job.variantId != null ? String(job.variantId).trim() : '';
      return /^\d+$/.test(v) ? v : '';
    };
    var fetchVariantDetail = function (vid) {
      if (!vid) return Promise.resolve(null);
      return fetch('/variants/' + encodeURIComponent(vid) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    };
    var fetchProduct = function (handle) {
      if (!handle) return Promise.resolve(null);
      return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    };
    var variantOptionsMap = function (v, product) {
      var map = {};
      if (!v) return map;
      var names = [];
      try {
        var opts = product && product.options;
        if (Array.isArray(opts)) {
          opts.forEach(function (o) {
            if (typeof o === 'string') names.push(o);
            else if (o && (o.name || o.title)) names.push(String(o.name || o.title));
          });
        } else if (product && typeof product === 'object') {
          ['option1', 'option2', 'option3'].forEach(function (k, i) {
            var nm = product[k];
            if (nm != null && String(nm).trim() !== '') names[i] = String(nm);
          });
        }
      } catch (e) {}
      if (Array.isArray(v.options)) {
        v.options.forEach(function (o, i) {
          var name = (o && (o.name || o.title)) ? String(o.name || o.title) : (names[i] || ('Option' + (i + 1)));
          var val = (o && o.value != null) ? String(o.value) : (v['option' + (i + 1)] != null ? String(v['option' + (i + 1)]) : '');
          if (val) map[name] = val;
        });
        return map;
      }
      ['option1', 'option2', 'option3'].forEach(function (k, i) {
        if (v[k] != null && String(v[k]).trim() !== '') map[names[i] || ('Option' + (i + 1))] = String(v[k]);
      });
      return map;
    };
    var productName = function (job) {
      if (job && job.productTitle) return String(job.productTitle);
      if (job && job.styleTitle) return String(job.styleTitle);
      if (job && job.productHandle) {
        var pretty = String(job.productHandle).replace(/-/g, ' ').replace(/\s+/g, ' ').trim();
        if (pretty) return pretty.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      }
      return 'Virtual Try-On';
    };
    var packText = function (job) {
      var x = job && job.packs != null ? String(job.packs).trim() : '';
      if (!x || x === 'all') return job && job.variantId ? '' : '\u2013';
      return /pack/i.test(x) ? x : x + ' packs';
    };
    var curId = null;
    var renderFallbackSpecs = function (container, rows) {
      if (!container) return;
      var doc = container.ownerDocument || document;
      container.innerHTML = '';
      var list = (rows || []).filter(function (row) { return row && row.label && row.value; });
      if (!list.length) list = [{ label: 'Specs', value: '\u2013' }];
      list.forEach(function (row) {
        var wrap = doc.createElement('div');
        var dt = doc.createElement('dt');
        var dd = doc.createElement('dd');
        dt.textContent = row.label;
        dd.textContent = row.value;
        wrap.appendChild(dt);
        wrap.appendChild(dd);
        container.appendChild(wrap);
      });
      container.hidden = false;
    };
    var paintSpecs = function (jobId, v, product) {
      if (jobId !== curId) return;
      var job = null;
      try { job = host.findJob(jobId); } catch (e) { job = null; }
      var prodEl = q('product');
      if (prodEl && product && product.title) prodEl.textContent = product.title;
      var specsEl = q('specs');
      var cartEl = q('cart');
      if (typeof host.renderSpecs === 'function') {
        try {
          var handled = host.renderSpecs(job, { product: product, variant: v, container: specsEl, cart: cartEl });
          if (handled !== false) return;
        } catch (e) {}
      }
      var commerce = window.JalizaTryOnCommerce;
      if (commerce && commerce.renderJobSpecs) {
        commerce.renderJobSpecs(job, product, v, specsEl, { currency: 'USD' });
        return;
      }
      var rows = [];
      if (job && job.color) rows.push({ label: 'Color', value: job.color });
      if (job && job.length) rows.push({ label: 'Length', value: job.length });
      var pack = packText(job);
      if (pack) rows.push({ label: 'Quantity', value: pack });
      if (v && v.price != null) rows.push({ label: 'Price', value: money(v.price) });
      renderFallbackSpecs(specsEl, rows);
    };
    var setDialogImage = function (img, job) {
      if (!img) return;
      var sources = [];
      var seen = {};
      var add = function (url, retry) {
        url = String(url == null ? '' : url).trim();
        if (!url || seen[url]) return;
        seen[url] = true;
        sources.push({ url: url, retry: retry !== false });
      };
      if (job && job.resultUrl) {
        add(job.resultUrl, true);
        add(job.resultThumbUrl, false);
      } else {
        add(job && job.skuImageUrl, true);
      }
      var host = img.parentNode;
      var generation = (img.__vtoImageGeneration || 0) + 1;
      img.__vtoImageGeneration = generation;
      var index = 0;
      var retried = {};
      var done = false;
      var isCurrent = function () { return img.__vtoImageGeneration === generation; };
      var finish = function (ok) {
        if (done || !isCurrent()) return;
        done = true;
        img.classList.remove('is-image-loading');
        if (ok) {
          img.style.visibility = '';
          img.classList.remove('is-image-failed');
          if (host && host.classList) host.classList.remove('has-image-failure');
          return;
        }
        img.classList.add('is-image-failed');
        img.style.visibility = 'hidden';
        img.alt = '';
        if (host && host.classList) host.classList.add('has-image-failure');
      };
      var attempt = function () {
        if (done || !isCurrent()) return;
        var item = sources[index];
        if (!item) { finish(false); return; }
        img.classList.add('is-image-loading');
        img.src = item.url;
      };
      img.onload = function () { if (img.naturalWidth > 0) finish(true); };
      img.onerror = function () {
        if (done || !isCurrent()) return;
        var item = sources[index];
        if (item && item.retry && !retried[item.url]) {
          retried[item.url] = true;
          setTimeout(function () {
            if (done || !isCurrent()) return;
            img.removeAttribute('src');
            img.src = item.url;
          }, 600);
          return;
        }
        index += 1;
        if (index < sources.length) attempt();
        else finish(false);
      };
      attempt();
    };
    var open = function (jobId) {
      var job = null;
      try { job = host.findJob(jobId); } catch (e) { job = null; }
      if (!job || (!job.resultUrl && !host.failedCopy)) return false;
      if (typeof host.canOpen === 'function') {
        var allowed = true;
        try { allowed = host.canOpen(job) !== false; } catch (e) { allowed = true; }
        if (!allowed) return false;
      }
      curId = jobId;
      var title = q('title');
      if (title) title.textContent = 'AI TRY-ON';
      var img = q('image');
      if (img) {
        img.loading = 'eager';
        img.decoding = 'async';
        img.fetchPriority = 'high';
        img.alt = job.resultUrl ? productName(job) + ' enlarged Virtual Try-On picture' : productName(job) + ' reference photo';
        setDialogImage(img, job);
      }
      var notice = q('aiNotice');
      if (notice) notice.hidden = false;
      var prod = q('product');
      if (prod) prod.textContent = productName(job);
      var specsEl = q('specs');
      if (specsEl) renderFallbackSpecs(specsEl, [{ label: 'Specs', value: 'Loading\u2026' }]);
      var cartEl = q('cart');
      if (cartEl) { cartEl.disabled = false; cartEl.textContent = 'ADD TO CART'; }
      var vid = variantOf(job);
      if (vid) {
        Promise.all([fetchVariantDetail(vid), fetchProduct(job.productHandle)]).then(function (pair) {
          paintSpecs(jobId, pair && pair[0], pair && pair[1]);
        });
      } else {
        paintSpecs(jobId, null, null);
      }
      var regen = q('regenerate');
      if (regen) regen.hidden = (job.retryCount || 0) >= 5;
      var copy = null;
      try { copy = host.failedCopy ? host.failedCopy(job) : null; } catch (e) { copy = null; }
      if (cartEl) {
        if (copy && copy.cart) cartEl.textContent = copy.cart;
        else cartEl.textContent = 'ADD TO CART';
      }
      if (regen && copy && typeof copy.regenerateHidden === 'boolean') regen.hidden = copy.regenerateHidden;
      show();
      track('result_open');
      return true;
    };
    var close = function () { hide(); };
    /* 按钮只绑一次（弹窗常驻 DOM，x-modal 搬家不影响） */
    var bound = false;
    var bind = function () {
      if (bound) return;
      bound = true;
      var on = function (name, fn) {
        var el = q(name);
        if (!el || el._vtoResultBound) return;
        el._vtoResultBound = true;
        el.addEventListener('click', fn);
      };
      on('close', function () { hide(); });
      var modalEl = modal();
      var overlay = modalEl && modalEl.querySelector('.fixed-modal');
      if (overlay && !overlay._vtoResultBound) {
        overlay._vtoResultBound = true;
        overlay.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          hide();
        });
      }
      on('download', function () {
        var job = null;
        try { job = host.findJob(curId); } catch (e) { job = null; }
        if (!job || !job.resultUrl) { toast('This picture could not be downloaded.'); return; }
        var a = document.createElement('a');
        a.href = job.resultUrl;
        a.download = 'jaliza-try-on-' + job.id;
        a.target = '_blank';
        a.rel = 'noopener';
        document.body.appendChild(a); a.click(); a.remove();
        toast('Try-On picture downloaded.');
        track('result_download');
      });
      on('share', function () {
        var job = null;
        try { job = host.findJob(curId); } catch (e) { job = null; }
        if (!job || !job.resultUrl) return;
        var done = function () { toast('Picture link copied.'); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(job.resultUrl).then(done, function () {});
        else toast('Copy this link: ' + job.resultUrl, 5000);
        track('result_share');
      });
      on('delete', function () {
        var job = null;
        try { job = host.findJob(curId); } catch (e) { job = null; }
        if (!job) return;
        var handled = false;
        try { handled = host.confirmDelete ? host.confirmDelete(job) === true : false; } catch (e) { handled = false; }
        if (handled) return;
        hide();
        var client = host.client;
        if (!client) return;
        var render = function () { try { if (host.afterDelete) host.afterDelete(job.id); } catch (e) {} };
        if (String(job.status).toLowerCase() !== 'done') {
          client.cancel(job.id).then(function () { toast('Try-On cancelled.'); render(); })
            .catch(function () { toast('Cancel failed, please retry.'); });
        } else {
          client.deleteJob(job.id).then(function () { toast('Try-On picture deleted.'); render(); })
            .catch(function () { toast('Delete failed, please retry.'); });
        }
        track('result_delete');
      });
      on('cart', function () {
        var job = null;
        try { job = host.findJob(curId); } catch (e) { job = null; }
        if (!job) { toast('Open the product page to shop this look.'); return; }
        var retry = null;
        try { retry = host.onRetry ? host.onRetry(job, q('cart')) : null; } catch (e) { retry = null; }
        if (retry) return;
        try { host.onCart(job, q('cart')); } catch (e) {}
      });
      on('regenerate', function () {
        var job = null;
        try { job = host.findJob(curId); } catch (e) { job = null; }
        var client = host.client;
        if (!job || !client) return;
        if ((job.retryCount || 0) >= 5) { toast('This picture has reached its regeneration limit.'); return; }
        var btn = q('regenerate');
        if (btn) btn.disabled = true;
        client.retry(job.id).then(function (newJob) {
          hide();
          toast("Regenerating \u2014 we'll email you when it's ready.");
          var nid = (newJob && newJob.id) || job.id;
          try { if (host.afterRegenerate) host.afterRegenerate(nid); } catch (e) {}
          client.ensureSubscribed(nid);
          track('result_regenerate');
        }).catch(function (e) {
          if (e && e.status === 429) {
            var qm = (client && typeof client.quotaErrorMessage === 'function') ? client.quotaErrorMessage(e) : null;
            toast(qm || "You've used all 10 AI Try-Ons today! Come back tomorrow for more.");
          } else toast('Regenerate failed, please try again later.');
        }).then(function () { if (btn) btn.disabled = false; });
      });
    };
    bind();
    return { open: open, close: close, refresh: open, bind: bind, currentId: function () { return curId; } };
  }

  window.JalizaTryOnCore = {
    createClient: createClient,
    createFlow: createFlow,
    createResultDialog: createResultDialog,
    compressPhoto: compressPhoto,
    uuid: uuid,
    normalizeItem: normalizeItem,
    PROCESSING_REMINDER_DELAY: PROCESSING_REMINDER_DELAY,
    QUOTA_EXHAUSTED_COPY: QUOTA_EXHAUSTED_COPY,
    STILL_PROCESSING_COPY: STILL_PROCESSING_COPY,
    CHECK_LATER_COPY: CHECK_LATER_COPY
  };
})();
